<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/' + lang + '.png')">
        <span class="language-code">{{ languageCode }}</span>
        <span class="language-label">{{ languageLabel }}</span>
        <span class="language-arrow" />
      </div>
    </div>

    <div class="cont">
      <div class="bg-wrapper">
        <div class="logos">
          <div class="logo-card">
            <img
              v-if="config.logo"
              :src="config.logo"
              class="login-logo-img"
            >
          </div>
        </div>

        <div class="register-title">
          {{ $t("register.register") }}
        </div>

        <div class="inputs">
          <form class="form-signin">
            <div class="form-group">
              <div class="field-label account-label">
                <van-icon name="manager" />
                <span>{{ $t("register.inunanme") }}</span>
              </div>
              <input
                v-model.trim="data.unanme"
                type="text"
                class="form-control"
                :placeholder="$t('register.inunanme')"
                @input="chageuname"
              >
            </div>

            <div class="form-group">
              <div class="field-label password-label">
                <van-icon name="lock" />
                <span>{{ $t("login.password") }}</span>
              </div>
              <input
                v-model.trim="data.password"
                :type="password"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.password')"
              >
            </div>

            <div class="form-group">
              <div class="field-label password-label">
                <van-icon name="lock" />
                <span>{{ $t("login.password") }}</span>
              </div>
              <input
                v-model.trim="data.spassword"
                :type="password"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.spassword')"
              >
            </div>

            <div class="form-group">
              <div class="field-label invite-label">
                <van-icon name="coupon" />
                <span>{{ $t("feng.yaocode") }}</span>
              </div>
              <input
                v-model.trim="data.t_mobile"
                type="text"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.referralCode')"
              >
            </div>

            <div class="row mx-0 mt-4">
              <div
                class="registerBtn"
                @click="submit"
              >
                <span class="registerBtn-icon">🎬</span>
                {{ $t("register.signUpBtn") }}
              </div>
            </div>
          </form>

          <div class="row mx-0 text-center justify-content-center">
            <i>{{ $t("feng.hadacc") }}</i>
            <router-link
              class="link auth-link"
              to="/login"
            >
              {{ $t("register.signIn") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="statement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    />
    <van-dialog
      v-model="agreement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="agreementHider"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Dialog, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon).use(Dialog).use(Toast);

export default {
    name: "Register",
    data() {
        return {
            lang: localStorage.getItem("lang") || "en_us",
            time: 60,
            agreement: false,
            statement: false,
            show_kefu: false,
            msg_show: true,
            sex: "1",
            show_sms: "0",
            checked: false,
            password: "password",
            data: {
                password: "",
                spassword: "",
                paypwd: "",
                mobile: "",
                t_mobile: "",
                telacc: "",
                unanme: "",
                code: "",
                oaid: "",
                agent: ""
            },
            config: {}
        };
    },
    computed: {
        languageCode() {
            const codeMap = {
                en_us: "US",
                pt_br: "BR",
                ja_jp: "JP",
                ko_kr: "KR",
                zh_hk: "TW",
                th_th: "ES",
                vi_vn: "VN",
                id_ind: "ID",
                ms_my: "IT",
                zh_cn: "CN"
            };

            return codeMap[this.lang] || this.lang.slice(0, 2).toUpperCase();
        },
        languageLabel() {
            const labelMap = {
                en_us: "English",
                pt_br: "Português",
                ja_jp: "日本語",
                ko_kr: "한국인",
                zh_hk: "繁體中文",
                th_th: "Español",
                vi_vn: "Tiếng Việt",
                id_ind: "Indonesia",
                ms_my: "Italiano"
            };

            return labelMap[this.lang] || this.lang;
        }
    },
    created() {
        this.$parent.footer("user", false);
        this.getparams();
    },
    mounted() {
        this.data.agent = this.$route.query.agent || "";
        document.body.addEventListener(
            "focusout",
            () => {
                window.scrollTo(0, 0);
            },
            true
        );
        document.addEventListener("click", e => {
            if (e.target.className !== "mess_lang") {
                this.msg_show = true;
            }
        });
        Fetch("/index/webconfig", {
            type: "web"
        }).then(r => {
            this.config = r.data;
            this.show_sms = r.data.show_sms;
        });
    },
    methods: {
        chageuname() {
            this.data.unanme = this.data.unanme.replace(
                /[^a-zA-Z0-9]/g,
                ""
            );
        },
        isValidLoginAccount(value) {
            return /^[A-Za-z0-9]+$/.test(value);
        },
        kefu_to() {
            this.$router.push("/kefu");
        },
        showPwd() {
            if (this.password === "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        methodName(r) {
            if (r.status) {
                this.$router.replace(this.$router.history.current.query.redirect || "/");
            }
        },
        getExternalInfoData(info) {
            var parsedInfo = JSON.parse(info);
            console.log(parsedInfo);
            if (parsedInfo.code == 0) {
                this.data.oaid = parsedInfo.oaid;
            } else {
                this.data.oaid = "";
            }
        },
        getparams() {
            var that = this;
            try {
                window["getExternalInfoData"] = res => {
                    that.getExternalInfoData(res);
                };
                /* eslint-disable no-undef */
                rc_nativ.getDeviceInfo("getExternalInfoData");
                /* eslint-enable no-undef */
            } catch (e) {
                console.log(e);
            }
        },
        timeCall() {
            if (this.is_send) {
                this.is_send = false;
                return;
            }
            if (this.time > 0) {
                this.time--;
                return;
            }
            this.is_send = false;
        },
        sendcode() {
            if (this.time < 60 && this.time > 0) {
                return;
            }
            if (!this.data.mobile) {
                this.$toast(this.$t("register.testphone"));
                return false;
            }
            Fetch("/index/code", {
                mobile: this.data.mobile
            }).then(() => {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("register.sendSuccess")
                });
                this.time--;
            });
        },
        submit() {
            if (!this.data.unanme) {
                this.$toast(this.$t("register.inunanmeEmpty"));
                return false;
            }
            if (!this.isValidLoginAccount(this.data.unanme)) {
                this.$toast(this.$t("register.accountLettersNumbersOnly"));
                return false;
            }
            if (!this.data.password) {
                this.$toast(this.$t("register.passwordEmpty"));
                return false;
            }
            if (!this.data.spassword) {
                this.$toast(this.$t("register.confirmpassEmpty"));
                return false;
            }
            if (this.data.password != this.data.spassword) {
                this.$toast(this.$t("register.passwordnoconfirm"));
                return false;
            }
            this.data.mobile = this.data.unanme;
            Fetch("/index/register", {
                password: this.data.password,
                spassword: this.data.spassword,
                paypwd: this.data.paypwd,
                mobile: this.data.mobile,
                t_mobile: this.data.t_mobile,
                telacc: this.data.telacc,
                unanme: this.data.unanme,
                code: this.data.code,
                agent: this.data.agent
            }).then(() => {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("register.signUpSuccess")
                });

                Fetch("/index/login", {
                    username: this.data.mobile,
                    password: this.data.password
                }).then(res => {
                    localStorage.setItem("token", res.data.token);
                    this.$router.replace("/");
                });
            });
        },
        agreementShow() {
            this.agreement = true;
        },
        agreementHider() {
            this.agreement = false;
        },
        privacyStatementShow() {
            this.statement = true;
        },
        privacyStatementHide() {
            this.statement = false;
        },
        changeLang(lang) {
            this.lang = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            Toast.loading({
                message: "",
                forbidClick: true,
                duration: 1200
            });
            setTimeout(() => {
                location.reload();
            }, 500);
        }
    }
};
</script>

<style lang="less" scoped>
.basic_wrap {
    position: relative;
    display: block;
    width: 100%;
    max-width: 750px;
    min-height: 100vh;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;
    color: #f5f7ff;
    background:
        radial-gradient(
            circle at 76% 94%,
            rgba(20, 88, 136, 0.62) 0,
            rgba(20, 88, 136, 0) 34%
        ),
        linear-gradient(155deg, #1e203c 0%, #1c2547 48%, #12395f 100%);
    box-sizing: border-box;
    filter: none;
}

.basic_wrap::before,
.basic_wrap::after {
    position: absolute;
    top: -18%;
    bottom: -18%;
    width: 28%;
    background: rgba(255, 255, 255, 0.035);
    content: "";
    transform: skewX(-12deg);
    transform-origin: center;
    pointer-events: none;
}

.basic_wrap::before {
    left: 10%;
}

.basic_wrap::after {
    right: 12%;
    width: 26%;
    background: rgba(255, 255, 255, 0.04);
}

.login_bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 70px;
    background: transparent;
    box-sizing: border-box;
}

.login_bg .language {
    position: absolute;
    top: 12px;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 128px;
    height: 40px;
    padding: 0 12px;
    border-radius: 22px;
    background: rgba(3, 8, 22, 0.86);
    box-shadow: 0 8px 20px rgba(3, 8, 22, 0.24);
    box-sizing: border-box;
    overflow: hidden;
}

.login_bg .language img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.language-code {
    margin-left: 8px;
    color: rgba(255, 255, 255, 0.42);
    font-size: 12px;
    line-height: 1;
    text-transform: uppercase;
}

.language-label {
    max-width: 72px;
    margin-left: 6px;
    overflow: hidden;
    color: #f5f7ff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.language-arrow {
    width: 0;
    height: 0;
    margin-left: 8px;
    border-top: 6px solid rgba(255, 255, 255, 0.76);
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    flex-shrink: 0;
}

.cont {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.bg-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    padding: 62px 24px 28px;
    box-sizing: border-box;
}

.logos {
    display: flex;
    justify-content: center;
    width: 100%;
}

.logo-card {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    padding: 16px 18px;
    border-radius: 10px;
    box-sizing: border-box;
}

.login-logo-img {
    width: auto;
    max-width: 160px ;
    object-fit: contain;
    flex-shrink: 0;
}

.register-title {
    margin-top: 0;
    color: rgba(236, 240, 255, 0.72);
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0;
    text-align: center;
}

.inputs {
    width: 100%;
    max-width: 430px;
    margin-top: 44px;
    box-sizing: border-box;
}

.form-signin,
.form-group {
    width: 100%;
}

.form-group {
    margin-bottom: 18px;
}

.field-label {
    display: flex;
    align-items: center;
    min-height: 24px;
    margin-bottom: 8px;
    color: #eef2ff;
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}

.field-label .van-icon {
    margin-right: 10px;
    font-size: 18px;
}

.account-label .van-icon {
    color: #754786;
}

.password-label .van-icon,
.invite-label .van-icon {
    color: #ffd04d;
}

input {
    width: 100%;
    height: 46px;
    padding: 0 20px;
    border: 0;
    border-radius: 14px;
    outline: none;
    background: rgba(247, 247, 249, 0.96);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.74);
    color: #20243a;
    font-size: 16px;
    line-height: 46px;
    text-align: left;
    box-sizing: border-box;
}

input::placeholder {
    color: #999;
    font-size: 14px;
    font-weight: 400;
}

.row.mx-0.mt-4 {
    width: 100%;
}

.registerBtn {
    width: 100%;
    height: 44px;
    margin: 28px auto 0;
    border-radius: 14px;
    background: linear-gradient(90deg, #647ee9 0%, #8452b6 100%);
    box-shadow: 0 14px 28px rgba(65, 95, 210, 0.28);
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 44px;
    text-align: center;
}

.registerBtn-icon {
    display: inline-block;
    margin-right: 12px;
    font-size: 20px;
    line-height: 1;
    vertical-align: -1px;
}

.row.mx-0.text-center.justify-content-center {
    margin-top: 28px;
    color: rgba(236, 240, 255, 0.88);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
}

.row.mx-0.text-center.justify-content-center i {
    font-style: normal;
}

.auth-link {
    margin-left: 8px;
    color: #6e8dfb;
    font-size: 14px;
    font-weight: 700;
}

/deep/ .van-dialog {
    background: #292929;
    color: #f5f1ec;
}

@media screen and (max-height: 760px) {
    .bg-wrapper {
        padding-top: 52px;
        padding-bottom: 22px;
    }

    .logo-card {
        width: 150px;
        height: 76px;
        padding: 14px 16px;
    }

    .login-logo-img {
        max-width: 116px !important;
        max-height: 42px !important;
    }

    .register-title {
        margin-top: 12px;
    }

    .inputs {
        margin-top: 28px;
    }

    .form-group {
        margin-bottom: 12px;
    }

    .field-label {
        margin-bottom: 8px;
    }

    input {
        height: 44px;
        line-height: 44px;
    }

    .registerBtn {
        margin-top: 18px;
    }

    .row.mx-0.text-center.justify-content-center {
        margin-top: 20px;
    }
}
</style>
